import { render, staticRenderFns } from "./RamInfo.vue?vue&type=template&id=2433e78e&scoped=true"
import script from "./RamInfo.vue?vue&type=script&lang=js"
export * from "./RamInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2433e78e",
  null
  
)

export default component.exports